import { render } from "./newPro.vue?vue&type=template&id=65197344&scoped=true"
import script from "./newPro.vue?vue&type=script&lang=js"
export * from "./newPro.vue?vue&type=script&lang=js"

import "./newPro.vue?vue&type=style&index=0&id=65197344&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65197344"]])

export default __exports__